<section class="faq">
  <img src="assets/svg/faq.svg" alt="faq" class="faq-hero" />
  <div class="cards">
    <gs1-card name="faq-phone" type="icon">
      <img src="assets/svg/phone.svg" alt="faq-phone" height="51" width="51" />
      <div class="gs1-default-size title font-500">{{ 'home.faq.phone-title' | translate }}</div>
      <a class="gs1-little font-300" href="tel:01 40 22 18 00" (click)="trackContact('Par téléphone')">01 40 22 18 00</a>
    </gs1-card>
    <gs1-card name="faq-mail" type="icon">
      <img src="assets/svg/mail.svg" alt="faq-mail" height="51" width="51" />
      <div class="gs1-default-size title font-500">{{ 'home.faq.mail-title' | translate }}</div>
      <a class="gs1-little font-300" href="mailto:serviceclient@gs1fr.org" (click)="trackContact('Par mail')">serviceclient@gs1fr.org</a>
    </gs1-card>
  </div>

  <h2 class="gs1-h2 font-500">{{ 'home.faq.title' | translate }}</h2>
  <gs1-accordion (itemOpened)="trackQuestionOpened($event.index)">
    @for (faq of faqs; track $index) {
      <gs1-accordion-item color="blue" [title]="faq.question">
        <span [innerHTML]="faq.answer" class="componentbody-little-dark"></span>
      </gs1-accordion-item>
    }
  </gs1-accordion>
</section>
